export default __webpack_public_path__ + "static/media/package5.77db72c4.jpg";